import axios from "axios";
import { generateUUID } from "../helpers/uuidHelper";
import { isDemoMode, getApiBaseUrl } from "../helpers/envHelper";

export const setApiDefaults = (customerId, emsAdminId, jwtToken) => {
  const getAuthHeaderValue = () => "Bearer " + jwtToken;

  axios.defaults.baseURL = getApiBaseUrl(customerId);
  axios.defaults.headers.common["Authorization"] = getAuthHeaderValue();

  const demoModeAllowedUrls = ["/distribution-preview"];

  axios.interceptors.request.use(
    function (config) {
      if (
        isDemoMode() &&
        ["put", "post", "delete"].includes(config.method) &&
        !demoModeAllowedUrls.includes(config.url)
      ) {
        throw new axios.CanceledError("demoMode");
      }

      config.headers["x-correlation-id"] = generateUUID();
      config.headers["x-ems-admin-id"] = emsAdminId;

      return config;
    },
    function (error) {
      return Promise.reject(error);
    }
  );
};

export const invalidateJwt = (response, func) => {
  if (response.status === 401 && func) {
    func();
  }
};
